import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useClientAuth } from '../../contexts/ClientAuthContext';
import axios from 'axios';
import '../../styles/client/ClientDashboard.css';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ClientDashboard = () => {
  const navigate = useNavigate();
  const { client, token, logout, isAuthenticated } = useClientAuth();
  
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/client/login');
      return;
    }
    fetchDashboard();
  }, [isAuthenticated]);

  const fetchDashboard = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/api/client-portal/dashboard`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      setDashboardData(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Erreur chargement dashboard:', error);
      if (error.response?.status === 401) {
        logout();
        navigate('/client/login');
      }
      setLoading(false);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/client/login');
  };

  if (loading) {
    return (
      <div className="client-dashboard-loading">
        <div className="loading-spinner"></div>
        <p>Chargement...</p>
      </div>
    );
  }

  return (
    <div className="client-dashboard-page">
      <header className="dashboard-header">
        <div className="header-content">
          <h1>🌿 NVF - Espace Client</h1>
          <div className="header-actions">
            <span className="welcome-text">
              Bonjour, <strong>{dashboardData?.client.prenom}</strong>
            </span>
            <button onClick={handleLogout} className="btn-logout">
              🚪 Déconnexion
            </button>
          </div>
        </div>
      </header>

      <nav className="dashboard-nav">
        <Link to="/client/dashboard" className="nav-item active">
          🏠 Tableau de bord
        </Link>
        <Link to="/client/quotes" className="nav-item">
          📋 Mes devis
        </Link>
        <Link to="/client/property" className="nav-item">
          🌱 Ma propriété
        </Link>
      </nav>

      <div className="dashboard-container">
        <div className="welcome-card">
          <h2>Bienvenue dans votre espace client</h2>
          <p>Gérez vos devis et suivez vos services en toute simplicité.</p>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon">📋</div>
            <div className="stat-content">
              <h3>{dashboardData?.stats.total_devis || 0}</h3>
              <p>Devis total</p>
            </div>
          </div>

          <div className="stat-card success">
            <div className="stat-icon">✅</div>
            <div className="stat-content">
              <h3>{dashboardData?.stats.devis_acceptes || 0}</h3>
              <p>Devis acceptés</p>
            </div>
          </div>

          <div className="stat-card pending">
            <div className="stat-icon">⏳</div>
            <div className="stat-content">
              <h3>{dashboardData?.stats.devis_en_attente || 0}</h3>
              <p>En attente</p>
            </div>
          </div>
        </div>

        <div className="info-section">
          <h3>📄 Mes informations</h3>
          <div className="info-grid">
            <div className="info-item">
              <span className="info-label">📧 Email:</span>
              <span className="info-value">{dashboardData?.client.email}</span>
            </div>
            <div className="info-item">
              <span className="info-label">🏠 Adresse:</span>
              <span className="info-value">{dashboardData?.client.adresse}</span>
            </div>
            <div className="info-item">
              <span className="info-label">🏛️ Ville:</span>
              <span className="info-value">{dashboardData?.client.ville}</span>
            </div>
            <div className="info-item">
              <span className="info-label">📏 Superficie:</span>
              <span className="info-value">{dashboardData?.client.superficie_terrain?.toLocaleString() || 0} pi²</span>
            </div>
          </div>
        </div>

        <div className="quick-actions">
          <h3>🚀 Actions rapides</h3>
          <div className="actions-grid">
            <Link to="/client/quotes" className="action-card">
              <div className="action-icon">📋</div>
              <h4>Consulter mes devis</h4>
              <p>Voir l'historique complet</p>
            </Link>
            
            <Link to="/client/property" className="action-card">
              <div className="action-icon">🌱</div>
              <h4>Ma propriété</h4>
              <p>Informations du terrain</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientDashboard;
